import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    return (
        <div
            className="group cursor-pointer"
            onClick={() => navigate(`/template10/product/${product.id}`)}
        >
            {/* Image */}
            <div className="relative aspect-[3/4] overflow-hidden bg-[#FAFAF9] mb-4">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700"
                />
            </div>

            {/* Info — no border, no shadow, just text */}
            <div>
                <h3
                    className="text-[#1C1917] text-sm font-light mb-1 group-hover:underline underline-offset-4 decoration-[#78716C] transition-all duration-300"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                >
                    {product.name}
                </h3>
                {product.category && (
                    <p className="text-[#A8A29E] text-xs font-light mb-1">{product.category}</p>
                )}
                <div className="flex items-center gap-2">
                    <span className="text-[#78716C] text-sm font-normal">
                        {typeof product.price === 'number' ? `₹${product.price.toLocaleString('en-IN')}` : product.price}
                    </span>
                    {product.originalPrice && (
                        <span className="text-[#D6D3D1] text-xs font-light line-through">
                            ₹{product.originalPrice.toLocaleString('en-IN')}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
